import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import './styles/client-tokens.css';
import './styles/client-palettes.css';
import './styles/legacy-panel.css';
import App from './App.tsx';
import { ErrorFallback } from './components/ErrorFallback';
import { initSentry } from './lib/sentry';
import { captureEntryUtm, initTracking, installPortalRequestTracking } from './lib/tracking';
import { apiClient } from './lib/api/client';
import { installChunkReloadGuard } from './lib/chunkReload';
import { bootExplora } from './pages/explora/bootExplora';

// Explora's loader and its downloads start before anything else
bootExplora(window.location.pathname);
// A tab left open across a deploy reloads instead of failing on a removed chunk
installChunkReloadGuard();
// Initialize Sentry
initSentry();
// Before the router drops the query: a tagged arrival (/wa, /qr) skips "¿Cómo nos encontraste?"
captureEntryUtm();
// Product analytics (no-op unless VITE_MIXPANEL_ENABLED and a token are set)
initTracking();
// Client-portal events that are one request each (selections, PDFs, uploads), gated like every portal event
installPortalRequestTracking(apiClient);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <ErrorFallback error={error} resetError={resetError} />
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
